import React from 'react';

import { propTypes } from './ThesaurusGroupsRootProps';

import ThesaurusGroupsList from '../ThesaurusGroupsList';

import './ThesaurusGroupsRoot.scss';

function ThesaurusGroupsRoot(props) {
  const { filter, expandSearchOptions } = props;

  if (!filter) {
    return null;
  }

  const thesaurusRootId = filter.get('thesaurusRootId');

  if (!thesaurusRootId) {
    return null;
  }

  const displayNone = expandSearchOptions
    ? {
        display: 'none',
      }
    : {};

  return (
    <section style={displayNone} className="tree-view-dialog-thesaurus-root-wrapper">
      <div className="tree-view-dialog-thesaurus-root">
        <ThesaurusGroupsList {...props} identificatorOfBatchItems={thesaurusRootId} item={filter} />
      </div>
    </section>
  );
}

ThesaurusGroupsRoot.propTypes = propTypes;

export default ThesaurusGroupsRoot;
